export function shouldReopenJudgeSubmission(submitted, scoredRoundCount, totalRounds) {
  return submitted && scoredRoundCount < totalRounds;
}

// The ref reopened this judge's final card: the server flipped `complete` back off and stamped
// a new `reopenedAt`. Keyed on the timestamp (not just `complete === false`) so the stale
// pre-submit snapshot that can arrive right after a successful submit never reopens the card.
export function wasCardReopened(submitted, submission, lastSeenReopenedAt) {
  return Boolean(submitted && submission && !submission.complete
    && submission.reopenedAt && submission.reopenedAt !== lastSeenReopenedAt);
}

export function confirmedRoundIndexes(confirmedRounds) {
  return new Set((confirmedRounds || []).map((round, position) => round.roundIndex ?? position));
}
